import { render, staticRenderFns } from "./CsRevisionDetalles.vue?vue&type=template&id=8d5af724"
import script from "./CsRevisionDetalles.vue?vue&type=script&lang=js"
export * from "./CsRevisionDetalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports